import {
  Checkbox as ChakraCheckbox,
  CheckboxProps as CharkaCheckboxProps,
} from '@chakra-ui/react';

// @doc https://chakra-ui.com/docs/form/checkbox
export type CheckboxProps = CharkaCheckboxProps;
export const Checkbox = ChakraCheckbox;
